export const DomHelper = {
  getHeight() {
    return window.innerHeight;
  },

  getWidth() {
    return window.innerWidth;
  },
  
  getId(key){
    return `${key}-${new Date().getTime()}-${Math.floor(Math.random() * 10000)}`;
  }
};
